import React from 'react' // eslint-disable-line no-unused-vars
import { isMobileDevice } from '../functions.js'

// PureComponent is used to prevent re-rendering - iPhone X was seeing 
// images reload for each state change on Products page
class HeroImage extends React.PureComponent {
   
    render () {
        const {title, subTitle, imageDesktop, imageMobile} = this.props
        return (
            <React.Fragment>
                { isMobileDevice()
                    ? <HeroImageMobile title={title} subTitle={subTitle} image={imageMobile} />
                    : <HeroImageDesktop title={title} subTitle={subTitle} image={imageDesktop} />
                }
            </React.Fragment>
        )
    }
}


const HeroImageMobile = ({title, subTitle, image}) =>
    <div
        style={{
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '222px',
            textAlign: 'center',
            color: 'white',
            fontSize: '20px',
            fontWeight: 'bold'
        }}
    >
        <div
            style={{
                background: 'rgba(17, 42, 65, 0.60)',
                mixBlendMode: 'normal',
                width: '100%',
                height: '100%',
                padding: '25px',
                lineHeight: '27px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <div style={{ maxWidth: '900px'}}>
                {title}
                {
                    subTitle &&
                    <div style={{ fontSize: '16px', fontWeight: 'normal', lineHeight: '22px', padding: '8px 0' }}>
                            {subTitle}
                    </div>
                }
            </div>
        </div>
    </div>


const HeroImageDesktop = ({title, subTitle, image}) =>
    <div
        style={{
            backgroundImage: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '311px',
            textAlign: 'center',
            color: 'white',
            fontSize: '38px',
            fontWeight: 'bold',
        }}
    >
        <div
            style={{
                background: 'rgba(17, 42, 65, 0.60)',
                mixBlendMode: 'normal',
                width: '100%',
                height: '100%',
                padding: '25px',
                lineHeight: '1.16',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <div style={{ maxWidth: '900px'}}>
                {title}
                {
                    subTitle &&
                    <div style={{ fontSize: '20px', fontWeight: 'normal', lineHeight: 'normal', padding: '8px 0' }}>
                            {subTitle}
                    </div>
                }
            </div>
        </div>
    </div>

export default HeroImage


// WEBPACK FOOTER //
// ./src/mi-app/HeroImage.js